export enum ReportStatus {
  REPORT_PENDING = 'REPORT_PENDING',
  REPORTED = 'REPORTED',
  POSTED_TO_SAP = 'POSTED_TO_SAP',
  POSTING_FAILED = 'POSTING_FAILED',
}

export const ReportStatusLabel: Record<ReportStatus, string> = {
  [ReportStatus.REPORT_PENDING]: 'Report pending',
  [ReportStatus.REPORTED]: 'Reported',
  [ReportStatus.POSTED_TO_SAP]: 'Posted to SAP',
  [ReportStatus.POSTING_FAILED]: 'Posting failed',
};
